import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';

// Invitá amigos: enlace personal y progreso hacia el próximo mes de Premium gratis
export default function InvitarAmigos({ onCopiado }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.misReferidos().then(setD).catch(() => {}); }, []);
  if (!d || d.influencer) return null;

  const link = d.link.startsWith('http') ? d.link : `${window.location.origin}${d.link}`;
  const texto = `¡Sumate a Cupido con Mate, la app de citas de San Juan! 🧉💘 ${link}`;
  const enCurso = d.validos % d.porPremio;
  const copiar = async () => {
    try { await navigator.clipboard.writeText(link); onCopiado?.(); }
    catch { window.prompt('Copiá tu enlace:', link); }
  };
  const compartir = async () => {
    if (navigator.share) { try { await navigator.share({ title: 'Cupido con Mate', text: texto }); return; } catch { /* cancelado */ } }
    window.open(`https://wa.me/?text=${encodeURIComponent(texto)}`, '_blank', 'noopener');
  };

  return (
    <div className="invitar-amigos">
      <div className="invitar-titulo">🎁 Invitá amigos y ganá Premium gratis</div>
      <p className="invitar-texto">
        Por cada <strong>{d.porPremio} amigos</strong> que se registren con tu enlace y completen su perfil, te regalamos <strong>{d.diasPremio} días de Plan Premium</strong>.
      </p>
      <div className="invitar-link">
        <input className="form-input" readOnly value={link} onFocus={e => e.target.select()} aria-label="Tu enlace para invitar" />
        <button className="btn btn-sm btn-outline" onClick={copiar}>📋 Copiar</button>
        <button className="btn btn-sm btn-primary" onClick={compartir}>📲 Compartir</button>
      </div>
      <div className="invitar-progreso" aria-label={`${enCurso} de ${d.porPremio} amigos para tu próximo mes`}>
        {Array.from({ length: d.porPremio }, (_, i) => <span key={i} className={i < enCurso ? 'lleno' : ''}>{i < enCurso ? '💘' : '🤍'}</span>)}
      </div>
      <p className="invitar-estado">
        {enCurso} de {d.porPremio} para tu próximo mes gratis
        {d.premiados > 0 && <> · Ya ganaste {d.premiados} {d.premiados === 1 ? 'mes' : 'meses'} 🎉</>}
        {d.registrados > d.validos && <> · {d.registrados - d.validos} {d.registrados - d.validos === 1 ? 'amigo se registró' : 'amigos se registraron'} y todavía no completó su perfil</>}
      </p>
    </div>
  );
}
